import { i18nKeys } from '@/src/utils/i18n.utils';
import Avatar from '@amzn/awsui-chat-components/avatar';
import ChatBubble from '@amzn/awsui-chat-components/chat-bubble';
import { Box, Button, SpaceBetween } from '@amzn/awsui-components-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmResetBubble: React.FC<{ onCancel: () => void; onConfirm: () => void }> = memo(
  ({ onCancel, onConfirm }) => {
    const { t } = useTranslation();
    return (
      <ChatBubble
        avatar={<Avatar ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.system)} color="gen-ai" iconName="gen-ai" />}
        type="incoming"
        ariaLabel={t(i18nKeys.conversationalAI.ariaLabels.system)}
      >
        <Box variant="p" padding={{ bottom: 'm' }}>
          {t(i18nKeys.conversationalAI.resetConversation.confirmPrompt)}
        </Box>
        <SpaceBetween direction="horizontal" size="xs">
          <Button onClick={onCancel}>{t(i18nKeys.general.cancel)}</Button>
          <Button onClick={onConfirm} variant="primary">
            {t(i18nKeys.general.confirm)}
          </Button>
        </SpaceBetween>
      </ChatBubble>
    );
  }
);

export default ConfirmResetBubble;
